import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotas: RouteConfig[] = [
	{
		path: 'fechamentos',
		name: 'Fechamentos de Caixa',
		components: {
			default: () =>
				import('@/views/application/fechamentosdecaixa/TelaDeFechamentos.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'fechamentos-de-caixa' as TipoDeRecurso,
		},
	},
]
export default rotas
